/* This is generated code, don't alter */
var IfcSectionTypeEnum;
(function (IfcSectionTypeEnum) {
    IfcSectionTypeEnum[IfcSectionTypeEnum["UNIFORM"] = 0] = "UNIFORM";
    IfcSectionTypeEnum[IfcSectionTypeEnum["TAPERED"] = 1] = "TAPERED";
})(IfcSectionTypeEnum || (IfcSectionTypeEnum = {}));
const IfcSectionTypeEnumCount = 2;
export { IfcSectionTypeEnum, IfcSectionTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcSectionTypeEnum = new Int32Array([3]);
let prefixSumAddressIfcSectionTypeEnum = new Uint32Array([0, 9, 18]);
let slotMapIfcSectionTypeEnum = new Int32Array([1, 0]);
let encodedDataIfcSectionTypeEnum = (new TextEncoder()).encode(".TAPERED..UNIFORM.");
let IfcSectionTypeEnumSearch = new MinimalPerfectHash(gMapIfcSectionTypeEnum, prefixSumAddressIfcSectionTypeEnum, slotMapIfcSectionTypeEnum, encodedDataIfcSectionTypeEnum);
export { IfcSectionTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcSectionTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcSectionTypeEnumSearch, input, cursor, endCursor);
}
